export const isWithinBreakpoint = (range, width) => {
  const [min, max] = range;
  if (!max) {
    return width >= min;
  }
  return width >= min && width <= max;
};